// import { useMutation, useQueryClient } from '@tanstack/react-query';
// import { offerServices } from 'features/offer/services/offer.service';
// import { toast } from 'react-hot-toast';

// export const useCreateOffer = () => {
//   const queryClient = useQueryClient();

//   return useMutation({
//     mutationFn: (offerData) => offerServices.addOffer(offerData),
//     onSuccess: () => {
//       queryClient.invalidateQueries(['offers']);
//       toast.success('Offer created successfully');
//     },
//     onError: (error) => {
//       toast.error(error?.response?.data?.message || 'Failed to create offer');
//     },
//   });
// };

// export const useUpdateOffer = () => {
//   const queryClient = useQueryClient();

//   return useMutation({
//     mutationFn: ({ offerId, offerData }) =>
//       offerServices.updateOffer({ offerId, offerData }),
//     onSuccess: (data, variables) => {
//       queryClient.invalidateQueries(['offers']);
//       queryClient.invalidateQueries(['offers', variables.offerId]);
//       toast.success('Offer updated successfully');
//     },
//     onError: (error) => {
//       toast.error(error?.response?.data?.message || 'Failed to update offer');
//     },
//   });
// };

// export const useDeleteOffer = () => {
//   const queryClient = useQueryClient();

//   return useMutation({
//     mutationFn: (offerId) => offerServices.deleteOffer(offerId),
//     onSuccess: () => {
//       queryClient.invalidateQueries(['offers']);
//       toast.success('Offer deleted successfully');
//     },
//     onError: (error) => {
//       toast.error(error?.response?.data?.message || 'Failed to delete offer');
//     },
//   });
// };





import { useMutation, useQueryClient } from '@tanstack/react-query';
import { offerServices } from 'features/offer/services/offer.service';
import { toast } from 'react-hot-toast';

export const useCreateOffer = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (offerData) => offerServices.addOffer(offerData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['offers'] });
      toast.success('Offer created successfully');
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to create offer');
    },
  });
};

export const useUpdateOffer = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ offerId, offerData }) =>
      offerServices.updateOffer({ offerId, offerData }),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['offers'] });
      queryClient.invalidateQueries({ queryKey: ['offers', variables.offerId] });
      toast.success('Offer updated successfully');
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to update offer');
    },
  });
};

export const useDeleteOffer = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (offerId) => offerServices.deleteOffer(offerId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['offers'] });
      toast.success('Offer deleted successfully');
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to delete offer');
    },
  });
};